export enum VaultViewAllLoansTabTypes {
  DocumentList = "allLoansDocumentList",
  MERSInquiryDetails = "allLoansMersInquiryDetails",
  SearchResults = "allLoansSearchResults",
}

export const ALL_LOANS = "allLoans";
